'use client';

import { ErrorTemplate } from '@components/common/error-template';

interface RootLayoutErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function RootLayoutError({
  error,
  reset,
}: Readonly<RootLayoutErrorProps>) {
  return (
    <section className='flex-center content'>
      <ErrorTemplate
        error={error}
        message='An unexpected error occurred. Please try again.'
        reset={reset}
        actionHref='mailto:support@upcyclers.com'
        actionLabel='Contact Support'
      />
    </section>
  );
}
